import {
  HandCoins,
  TrendingUp,
  Briefcase,
  Lightbulb,
  Building2,
  Sprout,
} from "lucide-react";
import Reveal from "@/components/Reveal";

const CUSTOMER_TILES = [
  {
    icon: HandCoins,
    title: "Loans",
    desc: "14 loan products across personal, business, agri, housing, FD-backed, gold, plot & no-CIBIL inclusive lending.",
  },
  {
    icon: TrendingUp,
    title: "Investments",
    desc: "Mutual funds, SIPs, equity, debentures & G-Sec curated for steady wealth growth.",
  },
  {
    icon: Briefcase,
    title: "Asset Management",
    desc: "Portfolio diversification, risk management and active performance monitoring.",
  },
  {
    icon: Lightbulb,
    title: "Financial Consulting",
    desc: "Expert advisory on tax, retirement, business strategy and wealth planning.",
  },
  {
    icon: Building2,
    title: "Project Finance",
    desc: "Structured financing for infrastructure, real estate, industrial & business expansion projects.",
  },
  {
    icon: Sprout,
    title: "Wealth Creation",
    desc: "Goal-based planning that turns disciplined investing into long-term prosperity.",
  },
];

function Tile({ icon: Icon, title, desc, idx }) {
  const onMouseMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
  };
  return (
    <Reveal delay={idx * 70}>
      <div
        data-testid={`customer-tile-${title.toLowerCase().replace(/\s+/g, "-")}`}
        onMouseMove={onMouseMove}
        className="tile h-full"
      >
        <div className="flex items-center justify-between">
          <div className="tile-icon">
            <Icon size={26} strokeWidth={1.75} />
          </div>
          <span className="font-display text-white/15 text-2xl">0{idx + 1}</span>
        </div>
        <h3 className="mt-5 font-display text-2xl text-white tracking-wide uppercase">
          {title}
        </h3>
        <p className="mt-2 text-white/65 text-sm leading-relaxed">{desc}</p>
        <div className="mt-5 h-px w-full bg-gradient-to-r from-[#D4AF37]/40 via-transparent to-transparent" />
        <div className="mt-4 text-[11px] tracking-[0.2em] uppercase text-[#D4AF37]/80">
          Learn more →
        </div>
      </div>
    </Reveal>
  );
}

export default function CustomersBanner() {
  return (
    <section
      id="customers"
      data-testid="customers-banner"
      className="relative banner-navy text-white py-24 md:py-32 overflow-hidden noise-overlay frame-corners"
    >
      <div className="pointer-events-none absolute -top-32 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full border border-[#D4AF37]/10" />
      <div className="pointer-events-none absolute -top-20 left-1/2 -translate-x-1/2 w-[700px] h-[700px] rounded-full border border-[#D4AF37]/10" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="text-center">
            <span className="gold-divider text-[11px] tracking-[0.32em] uppercase">
              Building Wealth · Creating Value · Securing Your Future
            </span>
            <h2
              data-testid="customers-banner-title"
              className="font-display text-[40px] md:text-[64px] mt-5 leading-[1.05] tracking-tight"
            >
              Trusted financial solutions <br />
              for <em className="not-italic text-[#D4AF37]">every dream</em>
            </h2>
            <p className="mt-4 text-white/70 max-w-2xl mx-auto">
              Six service pillars under one roof — covering everything from inclusive lending to
              wealth creation for Bharat&apos;s next generation of borrowers and investors.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {CUSTOMER_TILES.map((t, i) => (
            <Tile key={t.title} {...t} idx={i} />
          ))}
        </div>

        <Reveal delay={200}>
          <div
            data-testid="customers-tagline"
            className="mt-16 md:mt-20 text-center"
          >
            <div className="gold-divider text-[10px] tracking-[0.4em] uppercase">
              Brand promise
            </div>
            <p className="font-script italic text-3xl md:text-4xl text-[#F0D788] mt-5">
              Your Goals, Our Commitment
            </p>
            <div className="mt-4 flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-white/80 text-sm md:text-base">
              <span>Building Wealth</span>
              <span className="text-[#D4AF37]">·</span>
              <span>Creating Value</span>
              <span className="text-[#D4AF37]">·</span>
              <span>Securing Your Future</span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
